import { useFetchEditableCoursesQuery, useFetchCoursesByGroupIdQuery, useFetchEditablePackagesQuery } from '../coursesApi';

export const useEditableCourses = (params = {}) => {
  return useFetchEditableCoursesQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      courses: data ?? [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useCoursesByGroupId = (params = {}) => {
  return useFetchCoursesByGroupIdQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      courses: data ?? [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useEditablePackages = (params = {}) => {
  return useFetchEditablePackagesQuery(params, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      packages: data ?? [],
      isLoading,
      isError,
      error,
    }),
  });
};
